import { useEffect, useState } from 'react'

import { countryCode } from 'utils/i18n'

import CookieAgreementCountry from './assets/json/cookie-agreement-country.json'

export default function useCookieAgreementCountry() {
  const [cookieAgreementCountry, setCookieAgreementCountry] = useState<'UNDEFINED' | 'OTHER' | 'EUROPE' | 'LATIN_AMERICA'>(
    'UNDEFINED'
  )

  useEffect(() => {
    const isEuropeCountry =
      CookieAgreementCountry.europe.find((country) => country === countryCode?.toString()?.toUpperCase()) !== undefined
    const isLatinAmericaCountry =
      CookieAgreementCountry.latinAmerica.find((country) => country === countryCode?.toString()?.toUpperCase()) !== undefined

    if (isEuropeCountry) {
      setCookieAgreementCountry('EUROPE')
    } else if (isLatinAmericaCountry) {
      setCookieAgreementCountry('LATIN_AMERICA')
    } else {
      setCookieAgreementCountry('OTHER')
    }
  }, [countryCode])

  return cookieAgreementCountry
}
